import { all } from "redux-saga/effects";
import authRoot from "./AuthSagas/watchers";
import profileRoot from "./ProfileSagas/watchers";
import projectRoot from "./ProjectSagas/watchers";


export default function* rootSaga() {
  yield all([projectRoot(), profileRoot(), authRoot()]);
}
